var _defs, _g, _path, _path2, _path3, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1366,
    zoomAndPan: "magnify",
    viewBox: "0 0 1024.5 576",
    height: 768,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "4ec5ab4845"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0.140625 L 1024 0.140625 L 1024 575.859375 L 0 575.859375 Z M 0 0.140625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2c52fb0201"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 281.710938 57.710938 L 741.988281 57.710938 L 741.988281 517.988281 L 281.710938 517.988281 Z M 281.710938 57.710938 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4ec5ab4845)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0 0.140625 L 1024 0.140625 L 1024 575.859375 L 0 575.859375 Z M 0 0.140625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0 0.140625 L 1024 0.140625 L 1024 575.859375 L 0 575.859375 Z M 0 0.140625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 571.953125 155.621094 L 451.941406 155.621094 C 412.195312 155.621094 379.816406 188 379.816406 227.746094 L 379.816406 347.757812 C 379.816406 387.503906 412.195312 419.882812 451.941406 419.882812 L 571.953125 419.882812 C 611.699219 419.882812 644.078125 387.503906 644.078125 347.757812 L 644.078125 227.941406 C 644.078125 188 611.699219 155.621094 571.953125 155.621094 Z M 621.394531 347.953125 C 621.394531 375.289062 599.289062 397.394531 571.953125 397.394531 L 451.941406 397.394531 C 424.601562 397.394531 402.308594 375.289062 402.308594 347.953125 L 402.308594 227.941406 C 402.308594 200.601562 424.601562 178.308594 451.941406 178.308594 L 571.953125 178.308594 C 599.289062 178.308594 621.394531 200.410156 621.394531 227.941406 Z M 621.394531 347.953125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 600.261719 215.53125 C 600.261719 224.449219 593.085938 231.816406 583.972656 231.816406 C 575.054688 231.816406 567.6875 224.644531 567.6875 215.53125 C 567.6875 206.613281 574.863281 199.246094 583.972656 199.246094 C 593.085938 199.441406 600.261719 206.613281 600.261719 215.53125 Z M 600.261719 215.53125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 511.851562 220.574219 C 474.820312 220.574219 444.574219 250.820312 444.574219 287.851562 C 444.574219 324.882812 474.820312 355.128906 511.851562 355.128906 C 548.882812 355.128906 579.128906 324.882812 579.128906 287.851562 C 579.128906 250.820312 549.074219 220.574219 511.851562 220.574219 Z M 511.851562 332.441406 C 487.226562 332.441406 467.257812 312.472656 467.257812 287.851562 C 467.257812 263.226562 487.226562 243.257812 511.851562 243.257812 C 536.472656 243.257812 556.441406 263.226562 556.441406 287.851562 C 556.441406 312.472656 536.472656 332.441406 511.851562 332.441406 Z M 511.851562 332.441406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2c52fb0201)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 511.851562 517.988281 C 385.050781 517.988281 281.710938 414.84375 281.710938 287.851562 C 281.710938 161.050781 385.050781 57.710938 511.851562 57.710938 C 638.84375 57.710938 741.988281 161.050781 741.988281 287.851562 C 741.988281 414.84375 638.84375 517.988281 511.851562 517.988281 Z M 511.851562 70.316406 C 391.835938 70.316406 294.316406 167.835938 294.316406 287.851562 C 294.316406 407.863281 391.835938 505.386719 511.851562 505.386719 C 631.863281 505.386719 729.386719 407.863281 729.386719 287.851562 C 729.386719 167.835938 631.863281 70.316406 511.851562 70.316406 Z M 511.851562 70.316406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.f0c2d3f157f13f5189fb186272189c54.svg";
export { ForwardRef as ReactComponent };